/* eslint-disable jira/filename-case */
export const RESOURCE_TYPE_NEXTGEN_BACKLOG_CUSTOM_FILTERS = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
export const RESOURCE_TYPE_NEXTGEN_BACKLOG_FILTER_REFINEMENT = 'NEXTGEN_BACKLOG_FILTER_REFINEMENT';
export const RESOURCE_TYPE_NEXTGEN_BACKLOG = 'NEXTGEN_BACKLOG';
